/**
 * Arredonda "meio para cima" (0,005 → 0,01) na quantidade de casas pedida —
 * por padrão 2, a precisão de moeda.
 *
 * `Math.round(valor * 100) / 100` não serve: o ponto flutuante representa
 * 1,005 como 1,00499999…, e a conta devolve 1,00. Normalizar o valor já
 * deslocado com `toPrecision(15)` descarta esse ruído antes de arredondar.
 *
 * Negativos arredondam pelo módulo (-1,005 → -1,01), simétrico aos positivos.
 */
export function roundHalfUp(value: number, decimals = 2): number {
  if (!Number.isFinite(value)) return value;
  const factor = 10 ** decimals;
  const shifted = Number((Math.abs(value) * factor).toPrecision(15));
  return (Math.sign(value) * Math.round(shifted)) / factor;
}
